import dayjs from 'dayjs'

// An investment's balance is considered outdated once its "as of" date
// (dateOfUserInfo) is this many days in the past.
const OUTDATED_BALANCE_DAYS = 185
const YEAR_IN_DAYS = 365

const getPostTaxAnnualContributions = user => {
  return user ? user.postTaxAnnualContributions : 0
}
const getPostTaxAnnualContribDollars = user => {
  return user ? user.postTaxAnnualContribDollars : 0
}

// How many days old an investment's balance information is. Investments with a
// missing or unparseable "as of" date are treated as current so we don't raise
// a data alert we can't substantiate.
const daysSinceUserInfo = investment => {
  const asOf = dayjs(investment?.dateOfUserInfo)

  return asOf.isValid() ? dayjs().startOf('day').diff(asOf.startOf('day'), 'day') : 0
}

const isOutdatedInvestment = investment => daysSinceUserInfo(investment) >= OUTDATED_BALANCE_DAYS

// Whose record this is, for the "(name's)" label beside an account or pension.
// Accounts and pensions both carry a nullable owner id, and a single-member
// guide has no spouse to fall back on, so ownership can genuinely be unknown --
// return null in that case and let the caller drop the label rather than
// dereference a spouse that isn't there.
const ownerFirstName = (ownerId, person, spouse) => {
  if (person && ownerId === person.id) {
    return person.preferredName || person.firstName
  }
  if (spouse && ownerId === spouse.id) {
    return spouse.firstName
  }
  return null
}

export {
  OUTDATED_BALANCE_DAYS,
  YEAR_IN_DAYS,
  getPostTaxAnnualContributions,
  getPostTaxAnnualContribDollars,
  daysSinceUserInfo,
  isOutdatedInvestment,
  ownerFirstName,
}
